import { useContext } from "react";
import { I18nContext } from "../provider/I18nProvider.jsx";

/**
 * @returns {{ lang: string, setLang: (l: string) => void, t: (key: string, fallback?: string) => string }}
 */
export function useI18n() {
  const ctx = useContext(I18nContext);
  if (!ctx) {
    throw new Error("useI18n must be used within I18nProvider");
  }
  return ctx;
}
